/* =====================================================
   MEDIA GALLERY (Dawn-compatible core)
   ===================================================== */
if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();

        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };

        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener(
          'slideChanged',
          debounce(this.onSlideChanged.bind(this), 500)
        );

        this.elements.thumbnails
          .querySelectorAll('[data-target]')
          .forEach((mediaToSwitch) => {
            mediaToSwitch
              .querySelector('button')
              .addEventListener(
                'click',
                this.onThumbnailClick.bind(this, mediaToSwitch.dataset.target)
              );
          });

        if (this.dataset.desktopLayout?.includes('thumbnail') && this.mql.matches) {
          this.removeListSemantic();
        }
      }

      onSlideChanged(event) {
        const mediaId = event.detail.currentElement.dataset.mediaId;
        this.syncMobileScroll(mediaId);
        this.setActiveThumbnailById(mediaId);
      }

      onThumbnailClick(mediaId) {
        this.setActiveMedia(mediaId);
        this.syncMobileScroll(mediaId);
      }

      setActiveMedia(mediaId) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');

        if (!activeMedia) return;

        this.elements.viewer
          .querySelectorAll('[data-media-id]')
          .forEach((el) => el.classList.remove('is-active'));

        activeMedia.classList.add('is-active');

        this.playActiveMedia(activeMedia);
        this.preventStickyHeader();
      }

      syncMobileScroll(mediaId) {
        if (!window.matchMedia('(max-width: 749px)').matches) return;

        const scroller = this.querySelector('.product__media-list');
        if (!scroller) return;

        const slides = Array.from(
          scroller.querySelectorAll('.product__media-item')
        );

        const index = slides.findIndex(
          (slide) => slide.dataset.mediaId === mediaId
        );

        if (index < 0) return;

        const slideWidth = slides[0].getBoundingClientRect().width;

        scroller.scrollTo({
          left: slideWidth * index,
          behavior: 'smooth',
        });

        scroller.dataset.activeIndex = index;
      }

      setActiveThumbnailById(mediaId) {
        const thumb = this.elements.thumbnails.querySelector(
          `[data-target="${mediaId}"]`
        );
        if (!thumb) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((el) => el.removeAttribute('aria-current'));

        thumb.querySelector('button').setAttribute('aria-current', true);
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        activeItem.querySelector('.deferred-media')?.loadContent(false);
      }

      preventStickyHeader() {
        document
          .querySelector('sticky-header')
          ?.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;

        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) =>
          slide.setAttribute('role', 'presentation')
        );
      }
    }
  );
}

/* =====================================================
   MOBILE ARROWS — INDEX-BASED + THUMBNAIL AWARE
   ===================================================== */
document.addEventListener('DOMContentLoaded', () => {
  if (!window.matchMedia('(max-width: 749px)').matches) return;

  const gallery = document.querySelector('media-gallery');
  if (!gallery) return;

  const scroller = gallery.querySelector('.product__media-list');
  if (!scroller) return;

  const slides = Array.from(
    scroller.querySelectorAll('.product__media-item')
  );
  if (!slides.length) return;

  let currentIndex = 0;

  const getSlideWidth = () =>
    slides[0].getBoundingClientRect().width;

  const syncIndexFromScroll = () => {
    const slideWidth = getSlideWidth();
    currentIndex = Math.round(scroller.scrollLeft / slideWidth);
  };

  const scrollToIndex = (index, behavior = 'smooth') => {
    index = Math.max(0, Math.min(slides.length - 1, index));
    currentIndex = index;

    const slideWidth = getSlideWidth();
    const mediaId = slides[index].dataset.mediaId;

    scroller.scrollTo({
      left: slideWidth * index,
      behavior,
    });

    // 🔗 Tell media-gallery which image is active
    gallery.querySelectorAll('[data-media-id]').forEach((el) =>
      el.classList.toggle('is-active', el.dataset.mediaId === mediaId)
    );

    gallery
      .querySelectorAll('[data-target] button')
      .forEach((btn) => btn.removeAttribute('aria-current'));

    const activeThumb = gallery.querySelector(
      `[data-target="${mediaId}"] button`
    );
    activeThumb?.setAttribute('aria-current', true);
  };

  document
    .querySelector('.ussf-media-nav__arrow--prev')
    ?.addEventListener('click', (e) => {
      e.preventDefault();
      syncIndexFromScroll();
      scrollToIndex(currentIndex - 1);
    });

  document
    .querySelector('.ussf-media-nav__arrow--next')
    ?.addEventListener('click', (e) => {
      e.preventDefault();
      syncIndexFromScroll();
      scrollToIndex(currentIndex + 1);
    });

  window.addEventListener(
    'resize',
    () => scrollToIndex(currentIndex, 'auto'),
    { passive: true }
  );
});
